import { Search } from "lucide-react";

import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

export function ExpandingSearchBar({
	placeholder,
	className,
	...props
}: React.InputHTMLAttributes<HTMLInputElement>) {
	return (
		<div
			className={cn(
				"relative grid grid-rows-1 grid-cols-1 group",
				className
			)}
		>
			<Input
				id="search-input"
				type="text"
				placeholder={placeholder ?? "Search..."}
				className="peer w-[200px] placeholder-shown:w-0 pr-8 transition-all duration-200 ease-in-out focus:w-[200px] col-start-1 col-span-1 row-start-1 row-span-1"
				{...props}
			/>
			<span
				className="pointer-events-none col-start-1 col-span-1 row-start-1 row-span-1 justify-self-center self-center cursor-pointer group-focus-within:justify-self-end group-focus-within:pr-2 peer-[&:not(:placeholder-shown)]:pr-2 peer-[&:not(:placeholder-shown)]:justify-self-end
"
			>
				<Search className="h-4 w-4" />
				<span className="sr-only">Search</span>
			</span>
		</div>
	);
}
